module.exports = __webpack_public_path__ + "static/img/home_fn_content_05.3d0c1b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/home_fn_content_05.png
// module id = G/Hb
// module chunks = 34